export default {
  title: "Architectures",
  create: "Create architecture",
  edit: "Edit architecture",
  delete: "Delete architecture",
  duplicate: "Duplicate architecture",
  rename: "Rename architecture",
  fields: {
    name: "Architecture name",
    description: "Description",
    provider: "Cloud provider",
    status: "Status",
    version: "Version",
    lastModified: "Last modified",
    createdBy: "Created by",
    estimatedCost: "Estimated cost"
  },
  status: {
    draft: "📝 Draft",
    validated: "✓ Validated",
    deployed: "🚀 Deployed"
  },
  providers: {
    azure: "Microsoft Azure",
    aws: "Amazon Web Services",
    gcp: "Google Cloud Platform"
  },
  messages: {
    createSuccess: "Architecture created successfully",
    updateSuccess: "Architecture updated successfully",
    deleteSuccess: "Architecture deleted successfully",
    duplicateSuccess: "Architecture duplicated successfully",
    renameSuccess: "Architecture renamed successfully",
    createError: "Error creating architecture",
    updateError: "Error updating architecture",
    deleteError: "Error deleting architecture",
    loadError: "Error loading architecture",
    confirmDelete: "Are you sure you want to delete this architecture?"
  },
  empty: {
    title: "No architectures",
    description: "Create your first architecture to get started",
    button: "Create architecture"
  },
  terraform: {
    generate: "Generate Terraform code",
    download: "Download Terraform",
    lastGenerated: "Last generated",
    generating: "Generating..."
  },
  modals: {
    createArchitecture: {
      title: "Create new architecture",
      projectLabel: "Project:",
      fields: {
        name: {
          label: "Architecture name *",
          placeholder: "E.g.: Web App Production Architecture"
        },
        description: {
          label: "Description",
          placeholder: "Brief description of the architecture..."
        },
        type: {
          label: "Architecture type",
          options: {
            webApp: "Web Application",
            microservices: "Microservices",
            dataProcessing: "Data Processing",
            iot: "IoT",
            machineLearning: "Machine Learning",
            serverless: "Serverless",
            containerOrchestration: "Container Orchestration",
            other: "Other"
          }
        },
        deploymentType: {
          label: "Deployment type",
          hint: "How this architecture will be deployed",
          options: {
            monoCloud: "Single-cloud",
            multiCloud: "Multi-cloud",
            hybrid: "Hybrid"
          }
        },
        template: {
          label: "Use a predefined template",
          options: {
            blank: "Blank",
            tier3: "Classic 3-tier architecture",
            microservicesK8s: "Microservices with K8s",
            serverlessLambda: "Serverless AWS Lambda",
            dataPipeline: "Data pipeline"
          }
        }
      },
      buttons: {
        cancel: "Cancel",
        create: "Create architecture"
      },
      errors: {
        nameRequired: "Architecture name is required!"
      }
    },
    createProject: {
      title: "Create new project",
      fields: {
        name: {
          label: "Project name *",
          placeholder: "E.g.: Production Infrastructure"
        },
        description: {
          label: "Description",
          placeholder: "Brief description of the project..."
        },
        provider: {
          label: "Cloud Strategy",
          hint: "The main cloud provider for this project",
          options: {
            azure: "Azure",
            aws: "AWS",
            gcp: "GCP",
            multiCloud: "Multi-cloud"
          }
        }
      },
      buttons: {
        cancel: "Cancel",
        create: "Create project"
      },
      errors: {
        nameRequired: "Project name is required!"
      }
    }
  }
};
